import { Engine } from 'engine/Engine';
import { Facet } from 'engine/facets/Facet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { V2 } from 'engine/lib/V2';
import random from 'lodash/random';

interface BlinkerProps {
  sprite: StaticSpriteFacet,
  frameOpen: JSX.Element | null,
  frameOpenRange: V2,
  frameClosed: JSX.Element | null,
  frameClosedRange: V2,
}

export class BlinkerBehavior extends Facet<BlinkerProps> {

  nextTransition = 0;
  paused = false;

  pause() {
    this.paused = true;
  }

  play(engine: Engine) {
    if (!this.paused) return;
    this.paused = false;
    this.nextTransition = engine.time.now + random(...this.props.frameOpenRange);
  }

  start(engine: Engine): void {
    this.props.sprite.props.frame = this.props.frameOpen;
    this.nextTransition = engine.time.now + random(...this.props.frameOpenRange);
  }

  update(delta: number, engine: Engine) {
    if (this.paused || engine.time.now < this.nextTransition) return;
    const { props } = this;
    if (props.sprite.props.frame === props.frameOpen) {
      props.sprite.props.frame = props.frameClosed;
      this.nextTransition = engine.time.now + random(...props.frameClosedRange);
    } else {
      props.sprite.props.frame = props.frameOpen;
      this.nextTransition = engine.time.now + random(...props.frameOpenRange);
    }
  }
}
